import { lockScroll, unlockScroll } from "./scroll-lock.js";

export function initMobileMenu(options = {}) {
	const { buttonSelector = "#btn-menu", headerSelector = "#header", stickySelector = ".sticky-wrapper", menuSelector = ".main-menu-wrap", activeClass = "active", breakpoint = 992 } = options;

	const btn = document.querySelector(buttonSelector);
	if (!btn) return;

	const targetHeader = document.querySelector(stickySelector) || document.querySelector(headerSelector);
	if (!targetHeader) return;

	const menu = document.querySelector(menuSelector);
	if (!menu) return;

	const mq = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
	let isMobile = mq.matches;
	let isOpen = false;

	function openMenu() {
		targetHeader.classList.add(activeClass);
		btn.classList.add(activeClass);

		const headerHeight = targetHeader.offsetHeight || 0;
		const menuHeight = window.innerHeight - headerHeight;

		menu.style.setProperty("--menu-top", `${headerHeight}px`);
		menu.style.setProperty("--menu-height", `${menuHeight}px`);

		lockScroll();
		isOpen = true;
	}

	function closeMenu() {
		if (!isOpen) return;

		targetHeader.classList.remove(activeClass);
		btn.classList.remove(activeClass);

		menu.style.removeProperty("--menu-top");
		menu.style.removeProperty("--menu-height");

		unlockScroll();
		isOpen = false;
	}

	function toggleMenu(e) {
		if (!isMobile) return;
		e.preventDefault();
		isOpen ? closeMenu() : openMenu();
	}

	function onBreakpointChange(e) {
		isMobile = e.matches;
		if (!e.matches) closeMenu();
	}

	btn.addEventListener("click", toggleMenu);
	mq.addEventListener("change", onBreakpointChange);

	return () => {
		btn.removeEventListener("click", toggleMenu);
		mq.removeEventListener("change", onBreakpointChange);
		closeMenu();
	};
}
